import ApplicationAdapter from './application';

export default class AccountListItemAdapter extends ApplicationAdapter {
  pathForType(): string {
    return 'accounts';
  }
}
